module.exports = __webpack_public_path__ + "static/media/fullscreen-open.12b5e87e.svg";